import { useState, useEffect, useCallback } from "react";

export default function useQuery(request, params) {
    const [data, setData] = useState(undefined)
    
    const _request = useCallback(
        async () => {
            const response = await request(params)
            if (response) {
                setData(response)
            }
        },
        // eslint-disable-next-line
        []
    )

    useEffect(
        () => {
            _request()
        },
        // eslint-disable-next-line
        []
    )

    return {
        data,
    }
}